import { ConditionalLink } from "components/conditionalLink";
import { Button } from "components/DesignSystem/Button/Button";
import { ArrowUpRight } from "components/icons/ArrowUpRight";
import { RESYNC_LOCKED_TEXT } from "constants/invoiceSourceSync";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";

// Why a locked-period invoice can't be resynced, with a way out to the lock date setting
export const LockedResyncTooltip = () => {
  const { link } = useConstructInternalLink();

  return (
    <div className="t-flex t-max-w-72 t-flex-col t-items-start t-gap-3 t-text-left">
      <span>{RESYNC_LOCKED_TEXT}</span>
      <ConditionalLink target="_blank" to={link("/books/books-settings")}>
        <Button type="button" size="small">
          <span className="t-flex t-items-center t-gap-1.5">
            Go to Settings
            <ArrowUpRight color="currentColor" />
          </span>
        </Button>
      </ConditionalLink>
    </div>
  );
};
